

function StripTeamTag(playerName) {
    
    return String(playerName).replace(/\b(?:3D!|Fox.|M8.|EL.|VES |Liquid`|MTE \||\[CDSG\])\b/gi, "").replace(/(?<=\s|^)(?:3D!|Fox.|M8.|EL.|VES |Liquid`|MTE \||\[CDSG\])(?=\s|$)/gi, "")
}

const TeamIcon = ({ playerName, className }) => {
    let icon = null
    let tag = null

    if (String(playerName).startsWith("3D!")) {
        icon = "/TeamIcons/3D.png"
        tag = "3D"
    }
    if (String(playerName).startsWith("Fox")) {
        icon = "/TeamIcons/Fox.png"
        tag = "FOX"
    }
    if (String(playerName).startsWith("M8")) {
        icon = "/TeamIcons/M8.png"
        tag = "M8"
    }
    if (String(playerName).startsWith("EL.")) {
        icon = "/TeamIcons/ELEPHANT.png"
        tag = "EL"
    }
    if (String(playerName).startsWith("VES")) {
        icon = "/TeamIcons/VES.png"
        tag = "VES"
    }
    if (String(playerName).startsWith("Liquid`")) {
        icon = "/TeamIcons/Liquid.webp"
        tag = "TL"
    }
    if (String(playerName).startsWith("MTE")) {
        icon = "/TeamIcons/MTE.png"
        tag = "MTE"
    }
    if (String(playerName).startsWith("[CDSG]")) {
        icon = "/TeamIcons/CDSG.png"
        tag = "CDSG"
    }

    if (icon) return (
        <div className={className + " flex flex-col"}>
            <img src={icon} className="aspect-square h-16 min-h-16 -z-10" />
            <h1 className="text-center text-2xl">{tag}</h1>
        </div>
    )
}

export { TeamIcon, StripTeamTag }